export const LEVEL_OPTIONS = [
  {
    label: 'Lv.1',
    value: ['1', '1'],
  },
  {
    label: 'Lv.2以下',
    value: ['1', '2'],
  },
  {
    label: 'Lv.3以下',
    value: ['1', '3'],
  },
  {
    label: 'Lv.4以下',
    value: ['1', '4'],
  },
  {
    label: 'Lv.5以下',
    value: ['1', '5'],
  },
];

export const ENTER_TIME_OPTIONS = [
  {
    label: '1小时内',
    value: ['3600000', '0'],
  },
  {
    label: '24小时内',
    value: ['86400000', '0'],
  },
  {
    label: '7天内',
    value: ['604800000', '0'],
  },
  {
    label: '14天内',
    value: ['1209600000', '0'],
  },
  {
    label: '1个月内',
    value: ['2592000000', '0'],
  },
  {
    label: '2个月内',
    value: ['5184000000', '0'],
  },
];

const MONTH_DATE_VAL = 60 * 60 * 24 * 30; // 秒级

export const INACTIVE_TIME_OPTIONS = [
  {
    label: '一个月',
    value: 0,
    range: [MONTH_DATE_VAL, 0],
  },
  {
    label: '三个月',
    value: 1,
    range: [MONTH_DATE_VAL * 3, 0],
  },
  {
    label: '六个月',
    value: 2,
    range: [MONTH_DATE_VAL * 6, 0],
  },
  {
    label: '一年',
    value: 3,
    range: [MONTH_DATE_VAL * 12, 0],
  },
];
export const INACTIVE_TYPE_OPTIONS = [
  {
    label: '未发言',
    value: 'message',
  },
  {
    label: '未语音',
    value: 'voice',
  },
  {
    label: '未浏览',
    value: 'visit',
  },
];
